import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { sortArrayByIds } from "./utils";
import MondayButton from "../../../commonComponents/MondayButton/MondayButton";
import { useDispatch } from "react-redux";
import { programFields as programFieldsReducer } from "../../../../store/actions";
import { API } from "aws-amplify";
import { message, Modal } from "antd";
import ChartCard from "./ChartCard";
import { ModalXIcon, SortIcon } from "../../../../assets/icons";

const ORGANIGRAMA_ORDER_FIELD_ID = "899555c7-f0f8-4d84-aba5-038c507f0a5e";

const SortModal = ({ open, setOpen, fetchedSrc, department, role }) => {
  const dispatch = useDispatch();

  const { isDarkMode } = useSelector((state) => state.usersList);
  const { programFields } = useSelector((state) => state.programFields);

  const [roleEmployees, setRoleEmployees] = useState([]);

  const { fieldIdx, orderIds } = useMemo(() => {
    if (!programFields) return {};

    const idx = programFields.findIndex(
      (field) => field?.fieldId === ORGANIGRAMA_ORDER_FIELD_ID
    );
    if (idx === -1) return {};

    return {
      fieldIdx: idx,
      orderIds: programFields[idx]?.fieldValues,
    };
  }, [programFields]);

  const handleDragEnd = (result) => {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) return;

    const updated = Array.from(roleEmployees);
    const [moved] = updated.splice(source.index, 1);
    updated.splice(destination.index, 0, moved);

    setRoleEmployees(updated);
  };

  const updateProgramFields = () => {
    const updatedFields = [...programFields];
    const previous = Array.isArray(updatedFields[fieldIdx].fieldOptions)
      ? {}
      : updatedFields[fieldIdx].fieldOptions;
    updatedFields[fieldIdx].fieldOptions = {
      ...previous,
      [department?.departmentId]: {
        ...previous[department?.departmentId],
        [role?.id]: roleEmployees.map((empl) => empl?.employeeId),
      },
    };
    dispatch(programFieldsReducer(updatedFields));
    setOpen(false);

    API.put("programFields", `/programFields/${ORGANIGRAMA_ORDER_FIELD_ID}`, {
      body: { fieldOptions: updatedFields[fieldIdx].fieldOptions },
    })
      .then(() => message.success("Renditja u ruajt me sukses!"))
      .catch((err) => console.log("Error: ", err));
  };

  useEffect(() => {
    if (!role?.employees) return;
    if (!orderIds) {
      setRoleEmployees(role?.employees);
      return;
    }

    const sortedEmployees = sortArrayByIds(
      role.employees,
      orderIds,
      "employeeId"
    );
    setRoleEmployees(sortedEmployees);
  }, [role?.employees, orderIds]);

  const fill = isDarkMode ? "#fbfbfb" : "#231f20";

  return (
    <Modal
      className={`organigramaSortModal ${
        isDarkMode ? "dark darkHeader" : "lightHeader"
      }`}
      onCancel={() => setOpen(false)}
      centered
      closeIcon={<ModalXIcon />}
      title={
        <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <SortIcon fill={fill} />
          Rendit Punonjësit në {role?.name}
        </span>
      }
      open={open}
      footer={[
        <MondayButton
          className="mondayButtonRed"
          onClick={() => setOpen(false)}
        >
          Anullo
        </MondayButton>,
        <MondayButton
          className="mondayButtonGreen"
          onClick={updateProgramFields}
        >
          Ruaj
        </MondayButton>,
      ]}
    >
      <div style={{ width: 300, margin: "auto" }}>
        <DragDropContext onDragStart={() => {}} onDragEnd={handleDragEnd}>
          <Droppable droppableId="list" style={{ transform: "none" }}>
            {(provided) => (
              <div
                className="sortDroppableColumn"
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {roleEmployees.map((employee, index) => (
                  <Draggable
                    key={employee.employeeId}
                    draggableId={String(employee.employeeId)}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        variant={snapshot.isDragging ? "elevation" : "outlined"}
                        elevation={4}
                        className="sortDraggableCard"
                        style={{ ...provided.draggableProps.style }}
                      >
                        <ChartCard
                          navigateOnClick={false}
                          employee={employee}
                          src={fetchedSrc?.[employee?.googleDriveFileId]}
                          setOpen={setOpen}
                        />
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </Modal>
  );
};

export default SortModal;
